// extracted by mini-css-extract-plugin
export default {"icon":"_5DOvB0c9","icon--has-avatar":"_5DaWpA1a","icon-image":"_5DuEBOXw","label":"_5DlNUtEt","menu-item":"_5DEZCKo7","menu-item--dropdown-value":"_5DqdiJWu"};